// for running dev with cert endpoints
const CERT = require('./config.cert');
const DEV = require('./config.dev');

export default {
  ...CERT,
  name: 'devCert',
  ampContent: DEV.ampContent,
  liftRoot: DEV.liftRoot,
};
